import { render, staticRenderFns } from "./goal_edit.vue?vue&type=template&id=5232b42d&scoped=true&"
import script from "./goal_edit.vue?vue&type=script&lang=js&"
export * from "./goal_edit.vue?vue&type=script&lang=js&"
import style0 from "./goal_edit.vue?vue&type=style&index=0&id=5232b42d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232b42d",
  null
  
)

export default component.exports